import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppStateInitialState } from './app.state';
import { PROGRAMS_NAMES } from '@/data';

const initialState = AppStateInitialState;

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    SET_NOTIFICATIONS: (state, action: PayloadAction<DashboardNotification[]>) => {
      state.notifications = action.payload;
    },
    SET_NOTIFICATION_TYPE: (state, action: PayloadAction<string>) => {
      state.notificationType = action.payload;
    },
    SET_PROG_IN_FULLSCREEN: (state, action: PayloadAction<string>) => {
      state.progIdInFullScreen = action.payload;
    },
    TOGGLE_LOADER: (state, action) => {
      state.isLoading = action.payload;
    },
    // TOGGLE_SELECTED_PROGRAM: (state, action: PayloadAction<string | number>) => {
    //   if (state.userSelectedPrograms === null) return;
    //   const programIndex = state.userSelectedPrograms.findIndex(
    //     (program) => program.id === action.payload
    //   );
    //   if (programIndex !== -1) {
    //     state.userSelectedPrograms[programIndex].isActive =
    //       !state.userSelectedPrograms[programIndex].isActive;
    //   }
    // },
    TOGGLE_SELECTED_PROGRAM: (state, action: PayloadAction<string | number>) => {
      if (state.userSelectedPrograms === null) return;

      state.userSelectedPrograms = state.userSelectedPrograms.map((program) =>
        Number(program.id) === Number(action.payload)
          ? { ...program, isActive: !program.isActive } // good
          : program
      );
    },
    SET_USER_SELECTED_PROGRAMS: (
      state,
      action: PayloadAction<{
        programsPermissions: AccountTypes['programsPermissions'];
        dashboardSettings: ISettings | null;
      }>
    ) => {
      const { programsPermissions, dashboardSettings } = action.payload;
      const userSelectedPrograms =
        programsPermissions?.map((permission) => ({
          id: permission.pvServiceID,
          programName: permission.pvServiceName,
          isActive: false,
        })) ?? [];

      const PROGRAMS_MAP = new Map(
        PROGRAMS_NAMES.map(({ value, label }) => [Number(value), label])
      );

      const availablePrograms = userSelectedPrograms
        .filter((program) => PROGRAMS_MAP.has(Number(program.id)))
        .map((program) => ({
          ...program,
          label: PROGRAMS_MAP.get(Number(program.id)) || '', // Add label from PROGRAMS_NAMES
        }));

      if (dashboardSettings && dashboardSettings.pvSettingValue) {
        try {
          const parsedSettings = JSON.parse(dashboardSettings.pvSettingValue);
          const selectedPrograms = parsedSettings?.selectedPrograms;

          if (selectedPrograms) {
            availablePrograms.forEach((program) => {
              (Object.values(selectedPrograms) as string[][]).forEach((columnValues: string[]) => {
                const numericValues = columnValues.map((val: string) => Number(val));
                if (numericValues.includes(Number(program.id))) {
                  program.isActive = true;
                }
              });
            });
          }
        } catch (error) {
          console.error('Failed to parse settings:', error);
        }
      }
      state.userSelectedPrograms = availablePrograms;
    },
    SET_SETTINGS_TIMEOUT_ID: (state, action: PayloadAction<number | null>) => {
      state.settingsTimeoutId = action.payload;
    },
    SET_PROGRAM_WS_UPDATES: (state, action: PayloadAction<number | number[]>) => {
      if (Array.isArray(action.payload)) {
        state.programsListWSUpdates = [...action.payload];
      } else {
        state.programsListWSUpdates = [...state.programsListWSUpdates, action.payload];
      }
    },
    REMOVE_PROGRAM_WS_UPDATES: (state, action: PayloadAction<number>) => {
      state.programsListWSUpdates = state.programsListWSUpdates.filter(
        (programId) => programId !== action.payload
      );
    },
    SET_HIGHLIGHTED_DATE: (state, action: PayloadAction<{ programId: string; date: string }>) => {
      const { programId, date } = action.payload;
      const existingHighlight = state.highlightedDates.find(
        (highlight) => highlight.programId === programId
      );

      if (!existingHighlight) {
        state.highlightedDates.push({ programId, date });
      } else {
        state.highlightedDates = state.highlightedDates.map((highlight) =>
          highlight.programId === programId ? { programId, date } : highlight
        );
      }
    },
    RESET_HIGHLIGHTED_DATES: (state) => {
      state.highlightedDates = [];
    },
  },
});

export default appSlice.reducer;
